import { defineStore } from 'pinia'
import { useMainStore } from './MainStore.js';
import Api from '../api/Api'

export const useCommonStore = defineStore('common', {
  state: () => ({
    dbLanguages: [],
  }),
  getters: {
    nodeTypes: function() {
      return {
        FOLDER: 1,
        PROJECT: 2,
        CLIENT: 3,
        TENANT: 4,
      };
    },
    projectStatuses: function() {
      return {
        LOGGING: 1,
        EDITING: 2,
        REVIEWING: 3,
        DELIVERED: 4,
      };
    },
    podStates: function() {
      return {
        ERROR: 0,
        PENDING: 1,
        PROCESSING: 2,
        COMPLETE: 3
      };
    },
    assetStates: function() {
      return {
        ERROR: 0,
        PENDING: 1,
        PROCESSING: 2,
        COMPLETE: 3
      };
    },
    podBadgeStatuses: function() {
      return {
        NOTSELECTED: 0,
        NEW: 1,
        DRAFT: 2,
        PRODUCTION: 3,
        REVIEW: 4,
        CORRECTION: 5,
        FINAL: 6,
      };
    },
    archiveStatus: function() {
      return {
        NOTARCHIVED: 0,
        ARCHIVED: 1,
        PENDING: 2,
        ARCHIVING: 3,
        UNARCHIVING: 4,
      };
    },
    interfaceLanguages: function() {
      return [
        {id: 1, name: "English", code: 'en'},
        {id: 2, name: "Dutch", code: 'nl'},
      ];
    },
    assetTypes: function() {
      return {
        RAW: 0,
        THUMBNAIL: 1,
        WEB: 2,
        SPEECHTOTEXT: 3,
        AUDIO: 4,
        LIVEPREVIEW: 5,
        VTT: 6,
        SRT: 7,
        EXTERNAL: 8,
        FRAME: 9,
        IMAGE: 10,
        VIDEO: 11,
        OTHER: 12,
        AUDIODESCRIPTION: 13,
      };
    },
    userTypes: function() {
      return {
        TEAM_MEMBER: '5093fd3d-5a15-41ae-ac47-cedce16dc983',
        CLIENT: 'daa9eb20-9e46-4806-8a21-fc361197a170',
      };
    },
    userType: function() {
      return {
        TEAM_MEMBER: 'teamMember',
        CLIENT: 'client',
      };
    },
    rootFolderId: function() {
      return 'd87e9fab-044c-432f-b1f6-6fb77ef4dc22';
    },
    accessType: function () {
      return {
        PUBLIC: 0,
        TEAM_ONLY: 1,
      };
    }
  },
  actions: {
    async downloadThings(payload) {
      const mainStore = useMainStore();
      try {
        const response = await Api.common.downloadThings(payload);
        if (response.url) {
          window.open(response.url, '_blank');
        } else {
          mainStore.createSnackbar({
            i18n: 'menus.topBars.downloadQueued',
            color: 'success',
          });
        }
      } catch (error) {
        const snack_1 = {
          replaceTCode: error.response.data.error?.code || error.response.data.error.code,
          replaceTParams: error.response.data.error?.params || {},
          replaceTFallback: error.response.data.error?.message || error.response.data.error.message,
          color: 'error',
        };

        mainStore.createSnackbar(snack_1);
      }
    },
    async downloadMediaNotes(payload) {
      const mainStore = useMainStore();

      try {
        const blob = await Api.common.downloadMediaNotes(payload);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = 'media-notes.txt';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        if (error.response?.data?.text) {
          const errorText = await error.response.data.text();

          try {
            const errorData = JSON.parse(errorText);
            const errorCode = errorData.error?.message?.code || errorData.error?.code;
            const errorMessage = errorData.error?.message?.content
              || errorData.error?.message
              || null;

            mainStore.createSnackbar({
              i18n: errorCode || errorMessage ? null : 'routes.pod.noNoteAvailable',
              message: errorCode ? null : errorMessage,
              replaceTCode: errorCode,
              replaceTParams: errorData.error?.message?.params || {},
              replaceTFallback: errorMessage,
              color: 'error',
            });
            return;
          } catch {
            // Fall through to the generic no-note message.
          }
        }

        const errorMessage = error.response?.data?.error?.message?.content
          || error.response?.data?.error?.message
          || null;
        const errorCode = error.response?.data?.error?.message?.code || error.response?.data?.error?.code;

        mainStore.createSnackbar({
          i18n: errorCode || errorMessage ? null : 'routes.pod.noNoteAvailable',
          message: errorCode ? null : errorMessage,
          replaceTCode: errorCode,
          replaceTParams: error.response?.data?.error?.message?.params || {},
          replaceTFallback: errorMessage,
          color: 'error',
        });
      }
    },
    async exportThings(payload) {
      const mainStore = useMainStore();
      try {
        const response = await Api.common.exportThings(payload);

        if (response.url) {
            window.open(response.url, '_blank');
        } else {
          const snack = {
              replaceTCode: response.message.code,
              replaceTParams: {},
              replaceTFallback: response.message.content,
              color: 'success'
          };

          mainStore.createSnackbar(snack);
        }
      } catch (error) {
        const snack_1 = {
          replaceTCode: error.response.data.error.message?.code || error.response.data.error.code,
          replaceTParams: error.response.data.error.message?.params || {},
          replaceTFallback: error.response.data.error.message?.content || error.response.data.error.message,
          color: 'error',
        };

        mainStore.createSnackbar(snack_1);
      }
    },
    sendSupportTicket: function(payload) {
      return Api.common.sendSupportTicket(payload);
    },
    sendFeatureRequest: function(payload) {
      return Api.common.sendFeatureRequest(payload);
    },
    async refreshLanuages() {
      const response = await Api.common.getLanguages();
      // console.log("Got db languages", response);
      this.dbLanguages = response.data;
    },
  },
});
